"use client";

import React, { useEffect, useState } from "react";
import { Facebook, Linkedin, Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
function DesktopMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="204968" className="flex gap-4">
        <div className="h-9 w-20 bg-muted animate-pulse rounded-sm" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-sm" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group inline-flex h-10 w-max items-center justify-center bg-transparent px-4 py-2 text-base font-medium font-serif text-foreground transition-colors relative">
                {item.label}
                <span className="absolute bottom-0 left-4 right-4 h-[1px] bg-accent-foreground scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-10 w-full bg-muted animate-pulse rounded-sm" />
        <div className="h-10 w-full bg-muted animate-pulse rounded-sm" />
        <div className="h-10 w-full bg-muted animate-pulse rounded-sm" />
      </div>;
  }
  return <nav className="flex flex-col gap-1">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="block px-4 py-3 text-lg font-medium font-serif text-foreground hover:bg-muted hover:text-primary rounded-sm transition-colors">
          {item.label}
        </Link>)}
    </nav>;
}
export default function SiteNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border" : "bg-background border-b border-transparent"}`}>
      <div className="max-w-full mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {}
          <div className="flex-shrink-0">
            <Link to="#" className="flex items-center gap-2">
              <img src="https://fun-tiger.10web.cloud/wp-content/uploads/2026/04/Logo.jpg" alt="Twins Landscaping Corp." className="h-16 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="hidden lg:flex flex-1 justify-center px-8">
            <MenuProvider menu_id="16">
              <DesktopMenu />
            </MenuProvider>
          </div>

          {}
          <div className="hidden lg:flex items-center gap-6 flex-shrink-0">
            <div className="flex items-center gap-3 text-accent-foreground">
              
              
            </div>
            <Link to="tel:8456596974">
              <Button size="lg" className="font-default font-semibold rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-all">Call Us at (845)-659-6974</Button>
            </Link>
          </div>

          {}
          <div className="lg:hidden flex items-center">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" aria-label="Open menu" className="text-foreground">
                  <Menu className="size-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px] bg-background border-l border-border">
                <div className="flex flex-col h-full mt-8">
                  <div className="flex-1 overflow-y-auto py-4">
                    <MenuProvider menu_id="16">
                      <MobileMenu />
                    </MenuProvider>
                  </div>
                  
                  
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </section>;
}